import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { Hero } from '@/components/sections/Hero';
import { About } from '@/components/sections/About';
import { Experience } from '@/components/sections/Experience';
import { ProjectCaseStudy } from '@/components/sections/ProjectCaseStudy';
import { Skills } from '@/components/sections/Skills';
import { Resumes } from '@/components/sections/Resumes';
import { Education } from '@/components/sections/Education';
import { Contact } from '@/components/sections/Contact';

export default function App() {
  return (
    <>
      {/*
        Skip link: the first thing a keyboard user reaches, letting them jump
        past the nav rather than tabbing through it on every page load. Visible
        only when focused.
      */}
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:top-3 focus:left-3 focus:z-[100] focus:rounded-lg focus:bg-primary focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-primary-foreground"
      >
        Skip to content
      </a>

      <Header />

      <main id="main">
        <Hero />
        <About />
        <Experience />
        <ProjectCaseStudy />
        <Skills />
        <Resumes />
        <Education />
        <Contact />
      </main>

      <Footer />
    </>
  );
}
